'use strict';

export let jsonstyle = [
    {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 40
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 20
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#1f0b17"
            },
            {
                "lightness": 0
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 21
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#3a1b2e"
            },
            {
                "lightness": "0"
            },
            {
                "visibility": "on"
            },
            {
                "saturation": "0"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "saturation": "-50"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#3a1b2e"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#3a1b2e"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": 17
            }
        ]
    }
]


export let pathCairns10Waypoints = [
    {location:{lat: -16.915766 ,lng: 145.774071 }, stopover:false},
    {location:{lat: -16.914008 ,lng: 145.772234 }, stopover:false},
    {location:{lat: -16.904537 ,lng: 145.763295 }, stopover:false},
    {location:{lat: -16.902778 ,lng: 145.761704 }, stopover:false},
    {location:{lat: -16.896567 ,lng: 145.757809 }, stopover:false},
    {location:{lat: -16.897522 ,lng: 145.755009 }, stopover:false},
    {location:{lat: -16.899226 ,lng: 145.755052 }, stopover:false},
    {location:{lat: -16.898887 ,lng: 145.753132 }, stopover:false},
    {location:{lat: -16.899493 ,lng: 145.748636 }, stopover:false},
    {location:{lat: -16.900047 ,lng: 145.749677 }, stopover:false},
    {location:{lat: -16.901074 ,lng: 145.750278 }, stopover:false},
    {location:{lat: -16.901084 ,lng: 145.751544 }, stopover:false},
    {location:{lat: -16.902552 ,lng: 145.750524 }, stopover:false},
    {location:{lat: -16.903774 ,lng: 145.750278 }, stopover:false},
    {location:{lat: -16.904174 ,lng: 145.754816 }, stopover:false},
    {location:{lat: -16.902614 ,lng: 145.757251 }, stopover:false},
    {location:{lat: -16.904359 ,lng: 145.758635 }, stopover:false},
    {location:{lat: -16.902819 ,lng: 145.761639 }, stopover:false},
    {location:{lat: -16.904882 ,lng: 145.762562 }, stopover:false},
    {location:{lat: -16.908691 ,lng: 145.765684 }, stopover:false},
    {location:{lat: -16.914008 ,lng: 145.771424 }, stopover:false},
    {location:{lat: -16.918914 ,lng: 145.776746 }, stopover:false}
]

export let pathCairns10Offset = {lat:-16.9072796,lng:145.7615777};
export let pathCairns10 = [
    {lat: -16.918804, lng: 145.777102},
    {lat: -16.915766 ,lng: 145.774071 },
    {lat: -16.914008 ,lng: 145.772234 },
    {lat: -16.904537 ,lng: 145.763295 },
    {lat: -16.902778 ,lng: 145.761704 },
    {lat: -16.896567 ,lng: 145.757809 },
    {lat: -16.897522 ,lng: 145.755009 },
    {lat: -16.899226 ,lng: 145.755052 },
    {lat: -16.898887 ,lng: 145.753132 },
    {lat: -16.899493 ,lng: 145.748636 },
    {lat: -16.900047 ,lng: 145.749677 },
    {lat: -16.901074 ,lng: 145.750278 },
    {lat: -16.901084 ,lng: 145.751544 },
    {lat: -16.902552 ,lng: 145.750524 },
    {lat: -16.903774 ,lng: 145.750278 },
    {lat: -16.904174 ,lng: 145.754816 },
    {lat: -16.902614 ,lng: 145.757251 },
    {lat: -16.904359 ,lng: 145.758635 },
    {lat: -16.902819 ,lng: 145.761639 },
    {lat: -16.904882 ,lng: 145.762562 },
    {lat: -16.908691 ,lng: 145.765684 },
    {lat: -16.914008 ,lng: 145.771424 },
    {lat: -16.918914 ,lng: 145.776746 },
    {lat: -16.918881, lng: 145.776885}
]



// WEBPACK FOOTER //
// ./src/js/map-style.js